export const ADMIN_CREDENTIALS_STORAGE_KEY = "token_admin";
export const CONSULTANT_LEVEL_PNH = "PNH";
export const CONSULTANT_LEVEL_PNP = "PNP";

export const APP_BACKOFFICE_ROLE_ID = "1";
export const APP_FINANCIAL_ROLE_ID = "2";
export const APP_ADMIN_ROLE_ID = "3";
export const APP_TI_ROLE_ID = "14";
export const APP_RH_ROLE_ID = "15";
export const APP_CX_ROLE_ID = "16";
export const APP_MARKETING_ROLE_ID = "19";
export const APP_BOARD_ROLE_ID = "20";
export const APP_BI_ROLE_ID = "21";
export const APP_MASTER_ROLE_ID = "28";
export const APP_CX_ANALYST_ROLE_ID = "29";
export const APP_CX_ADM_ROLE_ID = "30";
export const APP_MARKETING_ANALYST_ROLE_ID = "31";
export const APP_BI_ADM_ROLE_ID = "32";
export const APP_FINANCIAL_ANALYST_ROLE_ID = "35";
export const APP_FINANCIAL_ADM_ROLE_ID = "36";
export const APP_ACCOUNTING_ROLE_ID = "54";
export const APP_EMPLOYEE_PN_ROLE_ID = "55";

export const APP_HEAD_MICRO_FRANQUIAS_ROLE_ID = "62";

export const APP_INTELLIGENCE_ROLE_ID = "57";
export const APP_FTR_INVEST_ROLE_ID = "58";
export const APP_PEOPLE_ROLE_ID = "59";
export const APP_INNOVATION_ROLE_ID = "60";
export const APP_HOLDINGS_ROLE_ID = "61";

export const SPECIALIST_DEPT_NAMES = {
  14: 'FTR Invest',
  15: 'Holdings',
  16: 'Contábil',
  17: 'Futuro Intelligence',
  19: 'Meu Futuro Azul',
};

export const APP_CUSTOMER_ROLE_ID = "5";

export const APP_FOUNDER_ROLE_ID = "53";
export const APP_SUPPORT_ROLE_ID = "28";

export const FINANCIAL_MENU_ROLE_IDS = [
  APP_ADMIN_ROLE_ID,
  APP_BI_ADM_ROLE_ID,
  APP_FINANCIAL_ROLE_ID,
  APP_FINANCIAL_ADM_ROLE_ID,
  APP_FINANCIAL_ANALYST_ROLE_ID,
  APP_FOUNDER_ROLE_ID,
  APP_SUPPORT_ROLE_ID
];

export const FINANCIAL_PROFILE_MANAGER_ROLE_IDS = [
  APP_ADMIN_ROLE_ID,
  APP_FOUNDER_ROLE_ID,
];

export const APP_BUSINESS_PARTNER_ROLE_PNH = "6";
export const APP_BUSINESS_PARTNER_ROLE_PNC = "24";
export const APP_BUSINESS_PARTNER_ROLE_PNP = "7";
export const APP_BUSINESS_PARTNER_ROLE_APRENDIZ = "37";
export const APP_BUSINESS_PARTNER_ROLE_PNF = "8";
export const APP_BUSINESS_PARTNER_ROLE_EXPANSAO = "41";
export const APP_BUSINESS_PARTNER_ROLE_EXPANSAO2 = "48"
export const APP_BUSINESS_PARTNER_ROLE_PNM1 = "9";
export const APP_BUSINESS_PARTNER_ROLE_PNM2 = "10";
export const APP_BUSINESS_PARTNER_ROLE_PNM3 = "11";
export const APP_BUSINESS_PARTNER_ROLE_REGIONAL = "42";
export const APP_BUSINESS_PARTNER_ROLE_NACIONAL = "43";

export const APP_BUSINESS_PARTNER_ROLE_PNP1 = "25";
export const APP_BUSINESS_PARTNER_ROLE_PNP2 = "26";
export const APP_BUSINESS_PARTNER_ROLE_PNP3 = "27";

export const APP_BUSINESS_PARTNER_ROLE_FOCADO = "38";
export const APP_BUSINESS_PARTNER_ROLE_PROTAGONISTA = "39";
export const APP_BUSINESS_PARTNER_ROLE_CAMPEAO = "40";

export const APP_BUSINESS_PARTNER_ROLE_PNS = "12";
export const APP_BUSINESS_PARTNER_ROLE_FUTURO = "44";
export const APP_BUSINESS_PARTNER_ROLE_FF = "13";

export const APP_NETWORKER_FUTURO_INDICA = "49";
export const APP_NETWORKER_GERADOR_LEADS = "50";
export const APP_NETWORKER_FRANQUEADO_RECOMENDADOR = "51";
export const APP_NETWORKER_FRANQUEADO_VENDEDOR = "52";

export const TWO_FACTOR_REQUIRED = "2FA_REQUIRED";
export const TWO_FACTOR_OK = "OK";

export const LEADER_CONSULTANT_ROLES = [
  APP_BUSINESS_PARTNER_ROLE_PNF,
  APP_BUSINESS_PARTNER_ROLE_EXPANSAO,
  APP_BUSINESS_PARTNER_ROLE_EXPANSAO2,
  APP_BUSINESS_PARTNER_ROLE_PNM1,
  APP_BUSINESS_PARTNER_ROLE_PNM2,
  APP_BUSINESS_PARTNER_ROLE_REGIONAL,
  APP_BUSINESS_PARTNER_ROLE_PNM3,
  APP_BUSINESS_PARTNER_ROLE_NACIONAL,
  APP_BUSINESS_PARTNER_ROLE_PNS,
  APP_BUSINESS_PARTNER_ROLE_FUTURO,
  APP_BUSINESS_PARTNER_ROLE_FF,
];

export const PN_ROLES = [
  APP_BUSINESS_PARTNER_ROLE_PNH,
  APP_BUSINESS_PARTNER_ROLE_PNC,
  APP_BUSINESS_PARTNER_ROLE_PNP,
  APP_BUSINESS_PARTNER_ROLE_APRENDIZ,
  APP_BUSINESS_PARTNER_ROLE_PNF,
  APP_BUSINESS_PARTNER_ROLE_EXPANSAO,
  APP_BUSINESS_PARTNER_ROLE_EXPANSAO2,
  APP_BUSINESS_PARTNER_ROLE_PNM1,
  APP_BUSINESS_PARTNER_ROLE_PNM2,
  APP_BUSINESS_PARTNER_ROLE_PNM3,
  APP_BUSINESS_PARTNER_ROLE_REGIONAL,
  APP_BUSINESS_PARTNER_ROLE_NACIONAL,
  APP_BUSINESS_PARTNER_ROLE_PNP1,
  APP_BUSINESS_PARTNER_ROLE_PNP2,
  APP_BUSINESS_PARTNER_ROLE_PNP3,
  APP_BUSINESS_PARTNER_ROLE_FOCADO,
  APP_BUSINESS_PARTNER_ROLE_PROTAGONISTA,
  APP_BUSINESS_PARTNER_ROLE_CAMPEAO,
  APP_EMPLOYEE_PN_ROLE_ID,
];

export const BACKOFFICE_ROLES = [
  APP_BACKOFFICE_ROLE_ID,
  APP_ADMIN_ROLE_ID,
  APP_FINANCIAL_ROLE_ID,
  APP_TI_ROLE_ID,
  APP_RH_ROLE_ID,
  APP_CX_ROLE_ID,
  APP_MARKETING_ROLE_ID,
  APP_BOARD_ROLE_ID,
  APP_BI_ROLE_ID,
  APP_MASTER_ROLE_ID,
  APP_CX_ANALYST_ROLE_ID,
  APP_CX_ADM_ROLE_ID,
  APP_MARKETING_ANALYST_ROLE_ID,
  APP_BI_ADM_ROLE_ID,
  APP_FINANCIAL_ANALYST_ROLE_ID,
  APP_FINANCIAL_ADM_ROLE_ID,
  APP_ACCOUNTING_ROLE_ID,
  APP_INTELLIGENCE_ROLE_ID,
  APP_FTR_INVEST_ROLE_ID,
  APP_PEOPLE_ROLE_ID,
  APP_INNOVATION_ROLE_ID,
  APP_HOLDINGS_ROLE_ID,
  APP_HEAD_MICRO_FRANQUIAS_ROLE_ID,
];

export const NETWORKER_ROLES = [
  APP_NETWORKER_FUTURO_INDICA,
  APP_NETWORKER_GERADOR_LEADS,
  APP_NETWORKER_FRANQUEADO_RECOMENDADOR,
  APP_NETWORKER_FRANQUEADO_VENDEDOR
];

export const APP_CONTRACT_TYPE_PREPOSTO = "1";
export const APP_CONTRACT_TYPE_FRANQUEADO_PLANEJADOR = "2";
export const APP_CONTRACT_TYPE_FRANQUEADO_EXPANSAO = "3";
export const APP_CONTRACT_TYPE_CLT = "4";
export const APP_CONTRACT_TYPE_PJ = "5";
export const APP_CONTRACT_TYPE_GERADOR_LEADS = "6";
export const APP_CONTRACT_TYPE_FRANQUEADO_RECOMENDADOR = "7";
export const APP_CONTRACT_TYPE_FRANQUEADO_VENDEDOR = "8";
export const APP_CONTRACT_TYPE_ESTAGIO = "9";
export const APP_CONTRACT_TYPE_CONTA_AUTOMACAO = "10";
export const APP_CONTRACT_TYPE_COLABORADOR_PLANEJADOR = "11";

export const BACKOFFICE_CONTRACT_TYPES = [
  APP_CONTRACT_TYPE_CLT,
  APP_CONTRACT_TYPE_PJ,
  APP_CONTRACT_TYPE_ESTAGIO,
  APP_CONTRACT_TYPE_COLABORADOR_PLANEJADOR
];

export const PN_CONTRACT_TYPES = [
  APP_CONTRACT_TYPE_PREPOSTO,
  APP_CONTRACT_TYPE_FRANQUEADO_PLANEJADOR,
  APP_CONTRACT_TYPE_FRANQUEADO_EXPANSAO,
  APP_CONTRACT_TYPE_COLABORADOR_PLANEJADOR
];

export const NETWORKER_CONTRACT_TYPES = [
  APP_CONTRACT_TYPE_GERADOR_LEADS,
  APP_CONTRACT_TYPE_FRANQUEADO_RECOMENDADOR,
  APP_CONTRACT_TYPE_FRANQUEADO_VENDEDOR
];

export function isLeaderConsultant(user_role) {
  return user_role && LEADER_CONSULTANT_ROLES.includes(user_role.toString());
}

export function isPnRole(user_contract_type_id) {
  return user_contract_type_id && PN_CONTRACT_TYPES.includes(user_contract_type_id.toString());
}

export function isFounderRole(user_role) {
  return user_role && APP_FOUNDER_ROLE_ID === user_role.toString();
}

export function isBackofficeRole(user_contract_type_id) {
  return user_contract_type_id && BACKOFFICE_CONTRACT_TYPES.includes(user_contract_type_id.toString());
}

export function isNetworkerRole(user_contract_type_id) {
  return user_contract_type_id && NETWORKER_CONTRACT_TYPES.includes(user_contract_type_id.toString());
}

export function isFinancialAdmRole(user_role) {
  return user_role && APP_FINANCIAL_ADM_ROLE_ID === user_role.toString();
}

export function canAccessFinancialMenu(user_role) {
  return user_role && FINANCIAL_MENU_ROLE_IDS.includes(user_role.toString());
}

export function isAdminRole(user_role) {
  return user_role && APP_ADMIN_ROLE_ID === user_role.toString();
}

export function isPncOrAboveRole(user_role) {
  return (
    user_role &&
    PN_ROLES.filter((role) => role !== APP_BUSINESS_PARTNER_ROLE_PNH).includes(
      user_role.toString()
    )
  );
}

export function isFaOrAboveRole(user_role) {
  return (
    user_role &&
    PN_ROLES.filter(
      (role) =>
        role !== APP_BUSINESS_PARTNER_ROLE_PNH &&
        role !== APP_BUSINESS_PARTNER_ROLE_PNC &&
        role !== APP_BUSINESS_PARTNER_ROLE_PNP
    ).includes(user_role.toString())
  );
}

export function isPreposto(user_role) {
  return user_role && (APP_BUSINESS_PARTNER_ROLE_PNH === user_role.toString() ||
  APP_BUSINESS_PARTNER_ROLE_PNC === user_role.toString());
}

export function isFeOrAboveRole(user_role) {
  return (
    user_role &&
    [
      APP_BUSINESS_PARTNER_ROLE_EXPANSAO,
      APP_BUSINESS_PARTNER_ROLE_REGIONAL,
      APP_BUSINESS_PARTNER_ROLE_NACIONAL,
      APP_BUSINESS_PARTNER_ROLE_EXPANSAO2,
      APP_EMPLOYEE_PN_ROLE_ID,
    ].includes(user_role.toString())
  );
}

export function isFouderOrSupportRole(user_role) {
  return (
    user_role &&
    [
      APP_FOUNDER_ROLE_ID,
      APP_SUPPORT_ROLE_ID
    ].includes(user_role.toString())
  );
}

export function isRecruitmentRole(user_role) {
  return (
    user_role &&
    [
      APP_RH_ROLE_ID,
      APP_SUPPORT_ROLE_ID
    ].includes(user_role.toString())
  );
}
